import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { stripCacheBustParam } from './app/services/app-version.service';

Sentry.init({
  dsn: "https://47ddf2d2c40045124209dbddcc28040b@o4512262366560256.ingest.us.sentry.io/4512262374359040",
  environment: environment.production ? "production" : "development",
  integrations: [
    Sentry.replayIntegration()
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

stripCacheBustParam();

if (environment.production) {
  enableProdMode();
} else {
  document.title = '[Dev] Interconsulta';
  document.documentElement.classList.add('dev-build');
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error(err);
  Sentry.captureException(err);
});
